import type { UploadedFileEntry } from '@/lib/csv-import/api';

import { getEntityTypeLabel } from './entityTypeLabels';

/**
 * Get friendly display name for a file
 * For virtual files (with source_file_id), displays as "{EntityTypeLabel} ({source_filename})"
 * For regular files, displays the filename as-is
 */
export function getFileDisplayName(
  fileId: string,
  uploadedFiles: UploadedFileEntry[]
): string {
  const file = uploadedFiles.find(f => String(f.file_id) === fileId);
  if (!file) {
    return `File ${fileId}`;
  }

  // Virtual file: display as "EntityType (source_filename)"
  if (file.source_file_id !== undefined) {
    const sourceFile = uploadedFiles.find(
      f => f.file_id === file.source_file_id
    );
    const sourceFilename = sourceFile?.filename || file.filename || 'unknown';
    const label = getEntityTypeLabel(file.entity_type_name);
    return `${label} (${sourceFilename})`;
  }

  // Regular file: display filename. Source-driven imports (e.g. Lightfield)
  // materialize files with no filename at all — fall back to the entity-type
  // label so callers never render an empty name.
  return (
    file.filename ||
    getEntityTypeLabel(file.entity_type_name) ||
    `File ${fileId}`
  );
}
